import { render, staticRenderFns } from "./BaseHeaderImage.vue?vue&type=template&id=4aef7848&"
import script from "./BaseHeaderImage.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAppBar,VImg})
